import React from "react";
import { MotionConfig } from "framer-motion";
import { EASE, DURATION } from "./tokens";

// Honours prefers-reduced-motion globally: framer-motion disables
// transform/layout animation for users who request it, keeping only
// opacity transitions. Everything downstream inherits this automatically.
export function MotionProvider({ children }) {
  return (
    <MotionConfig
      reducedMotion="user"
      transition={{ duration: DURATION.normal, ease: EASE.standard }}
    >
      {children}
    </MotionConfig>
  );
}
